"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Packages = void 0;

var lodash_1 = __importDefault(require("lodash"));

var Terms_1 = require("./Terms/");

var Token_1 = require("./Token");

var Packages = function () {
  function Packages(engine) {
    this.engine = engine;
  }

  Packages.prototype.applyPackage = function (pkgId, configuration, selection, resp) {
    var _this = this;

    var pkg = this.engine.data.properties.byId[pkgId];
    var pkgAttribute = this.engine.getParentAttribute(pkg);

    if (configuration[pkgAttribute]) {
      this.removePackages([configuration[pkgAttribute]], configuration, selection, resp);
    }

    configuration[pkgAttribute] = pkgId;
    this.getIncludedIds(pkg).forEach(function (id) {
      if (lodash_1["default"].includes(_this.engine.data.attributes.allIds, id)) {
        var attribute = _this.engine.data.attributes.byId[id];

        var defaultProperty = _this.engine.getDefaultPropertyId(attribute);

        if (defaultProperty) {
          configuration[id] = defaultProperty;
        }

        return;
      }

      var property = _this.engine.data.properties.byId[id];

      var parentAttribute = _this.engine.getParentAttribute(property);

      var priorValue = resp.before[parentAttribute];

      if (lodash_1["default"].includes(_this.getIncludedIds(pkg), priorValue)) {
        configuration[parentAttribute] = priorValue;
        return;
      }

      configuration[parentAttribute] = id;
    });
  };

  Packages.prototype.attemptDowngrade = function (pkgId, removedSelection) {
    var _this = this;

    var removedPackage = this.engine.data.properties.byId[pkgId];
    var pkgAttribute = this.engine.getParentAttribute(removedPackage);
    var parentPackage = this.engine.data.attributes.byId[pkgAttribute];
    var siblingPackages = this.engine.getProperties(parentPackage).filter(function (id) {
      return id !== pkgId;
    });
    var remainingIncludes = lodash_1["default"].difference(this.getIncludedIds(removedPackage), lodash_1["default"].keys(removedSelection), lodash_1["default"].values(removedSelection));
    var applicableDowngrades = siblingPackages.filter(function (siblingId) {
      var sibling = _this.engine.data.properties.byId[siblingId];

      if (lodash_1["default"].intersection(_this.getIncludedIds(sibling), remainingIncludes).length === sibling.includes.length) {
        return true;
      }

      return false;
    });
    return applicableDowngrades;
  };

  Packages.prototype.getIncludedIds = function (doc) {
    var _this = this;

    return doc.includes.map(function (id) {
      return lodash_1["default"].isString(id) ? id : _this.engine.getId(id);
    });
  };

  Packages.prototype.getMatchingPackages = function (configuration, packages) {
    var _this = this;

    if (packages === void 0) {
      packages = {};
    }

    var matchingPackages = {};
    var configurationIds = lodash_1["default"].keys(configuration).concat(lodash_1["default"].values(configuration));
    lodash_1["default"].values(packages.byId).forEach(function (pkg) {
      var pkgId = _this.engine.getId(pkg);

      var isPkg = lodash_1["default"].includes(configurationIds, pkgId);
      var packageApplies = !lodash_1["default"].isEmpty(lodash_1["default"].intersection(_this.getIncludedIds(pkg), configurationIds));

      if (isPkg || packageApplies) {
        var parentAttribute = _this.engine.getParentAttribute(pkg);

        if (!matchingPackages[parentAttribute]) {
          matchingPackages[parentAttribute] = [];
        }

        if (pkgId) {
          matchingPackages[parentAttribute].push(pkgId);
        }
      }
    });
    return matchingPackages;
  };

  Packages.prototype.parsePackages = function (data) {
    var _this = this;

    var _a;

    var normalizedPackages = {
      allIds: [],
      byId: {}
    };
    var packages = lodash_1["default"].values((_a = data === null || data === void 0 ? void 0 : data.attributes) === null || _a === void 0 ? void 0 : _a.byId).filter(function (a) {
      return a.package;
    });
    var properties = lodash_1["default"].flatten(packages === null || packages === void 0 ? void 0 : packages.map(function (p) {
      return _this.engine.getProperties(p);
    }));
    properties === null || properties === void 0 ? void 0 : properties.forEach(function (prop) {
      normalizedPackages.allIds.push(prop);
      normalizedPackages.byId[prop] = data.properties.byId[prop];
    });
    return normalizedPackages;
  };

  Packages.prototype.removePackages = function (pkgIds, configuration, removedSelection, resp) {
    var _this = this;

    pkgIds.forEach(function (pkgId) {
      var pkg = _this.engine.data.properties.byId[pkgId];

      var pkgAttribute = _this.engine.getParentAttribute(pkg);

      delete configuration[pkgAttribute];

      _this.getIncludedIds(pkg).forEach(function (id) {
        if (lodash_1["default"].includes(_this.engine.data.attributes.allIds, id)) {
          delete configuration[id];
          return;
        }

        var property = _this.engine.data.properties.byId[id];

        var parentAttribute = _this.engine.getParentAttribute(property);

        delete configuration[parentAttribute];
      });

      if (resp.selection[pkgAttribute]) {
        return;
      }

      var applicableDowngrades = _this.attemptDowngrade(pkgId, removedSelection);

      if (applicableDowngrades.length === 1) {
        _this.applyPackage(applicableDowngrades[0], configuration, removedSelection, resp);

        return;
      }

      if (applicableDowngrades.length > 1) {
        var options = applicableDowngrades.map(function (pkgOptionId) {
          return {
            action: 'add',
            collection: _this.engine.getModelNames().collections.property,
            id: pkgOptionId
          };
        });
        resp.log.add(new Token_1.Token(Terms_1.Or), {
          or: options
        });
      }
    });
  };

  return Packages;
}();

exports.Packages = Packages;